import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import anchorlistReducer from "./anchorlistSlice";
import scenelistReducer from "./scenelistSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    anchorlist: anchorlistReducer,
    scenelist: scenelistReducer,
  },

  devTools: false,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
